import { render } from "./education.vue?vue&type=template&id=10945754&scoped=true"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"

import "./education.vue?vue&type=style&index=0&id=10945754&lang=less&scoped=true"
import "./education.vue?vue&type=style&index=1&id=10945754&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10945754"]])

export default __exports__